import { Card, CardContent } from "@/components/ui/card";

export const CaseInfoBlock = ({ caseDetails }) => {
  if (!caseDetails) return null;
  const items = [
    { label: "Appareil", value: caseDetails.device },
    { label: "Client", value: caseDetails.client || caseDetails.clientInitials },
    { label: "Problème initial", value: caseDetails.issue },
    { label: "Intervention", value: caseDetails.intervention },
    { label: "Résultat", value: caseDetails.outcome },
    { label: "Durée", value: caseDetails.duration },
    { label: "Coût final", value: caseDetails.cost },
  ];
  return (
    <section className="section-padding bg-slate-50" data-testid="case-info-block">
      <div className="container-custom max-w-3xl">
        <Card className="border-2 border-red-100">
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-6">Fiche du cas</h2>
            <dl className="space-y-3">
              {items.map((it) => (
                <div key={it.label} className="grid grid-cols-3 gap-3">
                  <dt className="text-sm font-semibold text-slate-500 col-span-1">{it.label}</dt>
                  <dd className="text-slate-800 col-span-2">{it.value}</dd>
                </div>
              ))}
            </dl>
            {caseDetails.clientTestimonial ? (
              <blockquote className="mt-6 pt-6 border-t border-slate-200">
                <p className="text-slate-700 italic leading-relaxed">
                  « {caseDetails.clientTestimonial} »
                </p>
                <footer className="mt-3 text-sm text-slate-500">
                  — {caseDetails.clientInitials || caseDetails.client}, client Mediastore Niort
                </footer>
              </blockquote>
            ) : null}
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
